<template>
	<div>
		<ly-dialog v-model="dialogVisible" :title="loadingTitle" width="640px" @closed="handleClose">
			<el-form :inline="false" :model="formData" :rules="rules" ref="rulesForm" label-position="right"
				label-width="auto">
				<el-form-item label="管理员名称：" prop="name">
					<el-input v-model="formData.name"></el-input>
				</el-form-item>
				<el-form-item label="登录账号：" prop="username">
					<el-input v-model.trim="formData.username"></el-input>
				</el-form-item>
				<el-form-item label="登录密码：" prop="password">
					<el-input v-model.trim="formData.password" clearable show-password></el-input>
				</el-form-item>
				<el-form-item label="角色：" prop="role">
					<el-select v-model="formData.role" multiple filterable clearable placeholder="请选择" style="width:100%">
						<el-option v-for="item in rolelist" :key="item.id" :label="item.name" :value="item.id" />
					</el-select>
				</el-form-item>
				<el-form-item label="部门：" prop="dept">
					<el-tree-select v-model="formData.dept" node-key="id" :data="options" check-strictly filterable clearable
						:render-after-expand="false" :props="{label:'name',value: 'id'}" style="width: 100%" placeholder="请选择" />
					<el-alert title="不选择部门则默认无任何数据权限" type="info" show-icon />
				</el-form-item>
				<el-form-item label="负责栏目" prop="managed_columns">
				  <el-cascader
				    style="width: 100%"
				    :show-all-levels="false"
				    :options="managed_columns"
				    v-model="formData.managed_columns"
				    :props="{
				      checkStrictly: true,
				      label: 'name',
				      value: 'id',
				      multiple: true,
				    }"
				    clearable
				  ></el-cascader>
				</el-form-item>

				<el-form-item label="状态：" prop="is_active">
					<el-switch v-model="formData.is_active" active-color="#13ce66" inactive-color="#ff4949">
					</el-switch>
				</el-form-item>
			</el-form>
			<template #footer>
				<el-button @click="handleClose" :loading="loadingSave">取消</el-button>
				<el-button type="primary" @click="submitData" :loading="loadingSave">确定</el-button>
			</template>
		</ly-dialog>
	</div>
</template>

<script>
	import {
		buildTree
	} from "@/utils/util.js";
	import {
		columnGet
	} from "@/api/court";
	import {
		apiSystemUserAdd,
		apiSystemUserEdit,
		apiSystemRole,
		apiSystemDept
	} from "@/api/api";
	import LyDialog from "@/components/dialog/dialog";
	import XEUtils from "xe-utils";
	import {
		deepClone
	} from "@/utils/util";
	export default {
		components: {
			LyDialog
		},
		emits: ['refreshData', 'closed'],
		name: "addAdmin",
		data() {
			return {
				dialogVisible: false,
				loadingSave: false,
				loadingTitle: '',
				formData: {
					name: '',
					username: '',
					password: '123456',
					managed_columns: [],
					dept: '',
					role: [],
					is_active: true,
					is_staff: true,
					identity: 1
				},
				managed_columns: [], //栏目
				rules: {
					name: [{
						required: true,
						message: '请输入管理员名称',
						trigger: 'blur'
					}],
					role: [{
						required: true,
						message: '请选择角色',
						trigger: 'blur'
					}],
					username: [{
						required: true,
						message: '请输入管理员用户名',
						trigger: 'blur'
					}],
					managed_columns: [{
						required: true,
						message: '请选择负责栏目',
						trigger: 'change'
					}],
					is_active: [{
						required: true,
						message: '请选择是否启用',
						trigger: 'blur'
					}]
				},
				rolelist: [],
				options: [],
			}
		},
		mounted() {
		  this.initPage()
		},
		methods: {
			initPage() {
			  columnGet({
			    page: 1,
			    limit: 10000,
					is_enable:true
			  }).then((res) => {
			    if (res.code == 2000) {
			      this.managed_columns = buildTree(res.data.data);
			    }
			  })
			},
			handleClose() {
				this.$emit('closed')
			},
			handleOpen(item, flag) {
				this.getapiSystemRole()
				this.getapiSystemDept()
				this.loadingTitle = flag
				this.dialogVisible = true
				if (item) {
					// 编辑管理员
					const param = deepClone(item)
					// 编辑时，将managed_columns从对象数组转换为id数组
					if (param.managed_columns && Array.isArray(param.managed_columns)) {
						param.managed_columns = param.managed_columns.map(column => {
							return typeof column === 'object' ? column.id : column
						})
					}
					this.formData = param
				} else {
					// 新增管理员，重置表单数据
					this.formData = {
						name: '',
						username: '',
						password: '123456',
						managed_columns: [],
						dept: '',
						role: [],
						is_active: true,
						is_staff: true,
						identity: 1
					}
				}

				this.formData.role = item ? item.role : []
			},
			submitData() {
				this.$refs['rulesForm'].validate(obj => {
					if (obj) {
						this.loadingSave = true
						let param = {
							...this.formData
						}
						// 处理负责栏目参数，确保传递正确的格式
						console.log('原始managed_columns:', param.managed_columns)
						if (param.managed_columns && param.managed_columns.length > 0) {
							// 处理级联选择器返回的数组结构
							let processedColumns = []
							param.managed_columns.forEach(item => {
								if (Array.isArray(item)) {
									// 如果是数组路径，取最后一个元素（选中的节点ID）
									if (item.length > 0) {
										processedColumns.push(item[item.length - 1])
									}
								} else if (item !== null && item !== undefined && item !== '') {
									// 如果是单个值，直接添加
									processedColumns.push(item)
								}
							})
							// 去重
							param.managed_columns = [...new Set(processedColumns)]
						} else {
							param.managed_columns = []
						}
						console.log('处理后managed_columns:', param.managed_columns)

						if (param.role) {
							let rolearr = []
							for (var r in param.role) {
								rolearr.push(param.role[r])
							}
							param.role = rolearr
						} else {
							param.role = []
						}
						if (param.dept) {
							if (typeof param.dept == 'object') {
								param.dept = param.dept[param.dept.length - 1]
							}
						} else {
							param.dept = ''
						}

						if (this.formData.nickname == "" || this.formData.nickname == undefined || this.formData.nickname
							.length <= 0 || this.formData.nickname == '""') {
							param.nickname = this.formData.name
						}
						if (this.formData.id) {
							apiSystemUserEdit(param).then(res => {
								this.loadingSave = false
								if (res.code == 2000) {
									this.$message.success(res.msg)
									this.handleClose()
									this.$emit('refreshData')
								} else {
									this.$message.warning(res.msg)
								}
							})
						} else {
							apiSystemUserAdd(param).then(res => {
								this.loadingSave = false
								if (res.code == 2000) {
									this.$message.success(res.msg)
									this.handleClose()
									this.$emit('refreshData')
								} else {
									this.$message.warning(res.msg)
								}
							})
						}

					}
				})
			},
			getapiSystemRole() {
				apiSystemRole({
					page: 1,
					limit: 999,
					status: 1
				}).then(res => {
					if (res.code == 2000) {
						this.rolelist = res.data.data
					} else {
						this.$message.warning(res.msg)
					}
				})
			},
			loadChild(treeNode, resolve) {
				if (treeNode.level == 0) {
					return resolve([])
				}
				var params = {
					lazy: true,
					parent: treeNode.data.id,
					page: 1,
					limit: 999
				}
				apiSystemDept(params).then(async res => {
					if (res.code == 2000) {
						resolve(res.data.data)
					} else {
						this.$message.warning(res.msg)
					}
				})
			},
			getapiSystemDept() {
				apiSystemDept({
					page: 1,
					limit: 999
				}).then(res => {
					if (res.code == 2000) {
						this.options = XEUtils.toArrayTree(res.data.data, {
							parentKey: 'parent'
						})
					} else {
						this.$message.warning(res.msg)
					}
				})
			},


		}
	}
</script>
<style scoped>
	.el-alert {
		padding: 4px 8px 4px 8px;
	}
</style>